import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Trash2, Sparkles } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAdminApi } from "@/hooks/useAdminApi";
import { fmtDate } from "@/pages/Blog";

export const BlogTab = () => {
  const call = useAdminApi();
  const [posts, setPosts] = useState([]);
  const load = () => api.get("/blog").then((r) => setPosts(r.data));
  useEffect(() => { load(); }, []);
  const generate = async () => {
    try { await call("post", "/admin/blog/generate"); toast.success("Writing a new article — it appears here in about a minute"); [45000, 75000, 110000].forEach((t) => setTimeout(load, t)); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const del = async (slug) => {
    if (!window.confirm("Delete this article?")) return;
    try { await call("delete", `/admin/blog/${slug}`); toast.success("Deleted"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-gray-400">A new article is published automatically every day at 09:00 UTC. <span className="font-mono">{posts.length}</span> published.</p>
        <button data-testid="admin-blog-generate" onClick={generate} className="h-10 px-4 rounded-md bg-emerald-500 text-[#08090C] font-bold inline-flex items-center gap-2 hover:bg-emerald-400"><Sparkles size={16} /> Write one now</button>
      </div>
      <div className="rounded-lg border border-white/10 bg-[#0F1117] divide-y divide-white/5">
        {posts.map((p) => (
          <div key={p.id} data-testid={`admin-blog-row-${p.slug}`} className="flex items-center gap-4 p-4">
            <div className="flex-1 min-w-0">
              <Link to={`/blog/${p.slug}`} className="font-semibold hover:text-emerald-400 line-clamp-1">{p.title}</Link>
              <p className="text-xs text-gray-500 mt-1">{fmtDate(p.created_at)} · {(p.keywords || []).slice(0, 3).join(", ")}</p>
            </div>
            <button data-testid={`admin-blog-delete-${p.slug}`} onClick={() => del(p.slug)} className="p-2 rounded hover:bg-red-500/10 text-red-400"><Trash2 size={15} /></button>
          </div>
        ))}
      </div>
    </div>
  );
};
